import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { JsonapiService, JsonApiConfig, JsonApiModelConfig, JsonApiModel, Attribute, ModelType } from './jsonapi.service';
import { environment } from '../../../environments/environment';

@JsonApiModelConfig({
  type: 'sites'
})
export class SiteModel extends JsonApiModel {
  @Attribute()
  code: string;

  @Attribute()
  name: string;

  @Attribute()
  location: string;

  @Attribute()
  'created-at': Date;

  @Attribute()
  'updated-at': Date;
}

const config: JsonApiConfig = {
  baseUrl: environment.api.base_url.replace(/\/+$/, ""),
  apiVersion: environment.api.version,
  models: {
    boats: SiteModel
  }
}

@Injectable({
  providedIn: 'root'
})
@JsonApiConfig(config)
export class SiteService extends JsonapiService {
  constructor(
    http: HttpClient
  ) {
    super(http);
  }
}